import {concat, Observable, of, timer as rxJsTimer} from 'rxjs';
import {map, takeWhile} from 'rxjs/operators';

export function timer(startTime: number, totalDurationSec: number, startImmediately = false): Observable<number> {
    return rxJsTimer(startImmediately ? 0 : 1000, 1000)
        .pipe(
            map(() => remainingSeconds(startTime, totalDurationSec)),
            takeWhile(time => time > 0, true)
        );
}

export function remainingSeconds(startTime: number, totalDurationSec: number): number {
    const time = totalDurationSec - Math.floor((new Date().getTime() - startTime) / 1000);
    return time >= 0 ? time : 0;
}

export function pausedState(pausedNow: boolean, secondsUntilToggle?: number): Observable<boolean> {
    if (secondsUntilToggle == null) {
        return of(pausedNow);
    }
    if (secondsUntilToggle <= 0) {
        return of(!pausedNow);
    }
    return concat(of(pausedNow), rxJsTimer(secondsUntilToggle * 1000).pipe(map(() => !pausedNow)));
}
